export function decodeJwt(token) {
    if (!token) return null;
  
    const payload = token.split('.')[1]; // pega a parte do meio
    try {
      // base64url -> base64 e decodifica UTF-8 (emails acentuados, etc.)
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const binary = atob(base64);
      const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
      const json = new TextDecoder('utf-8').decode(bytes);
      const decoded = JSON.parse(json);
      return decoded;
    } catch (error) {
      console.error("Erro ao decodificar token:", error);
      return null;
    }
  }